import { useRef, useState, useEffect } from "react";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import axios from "../../api/axios";
//import "./register.css";
import { NavLink } from "react-router-dom";

//mui
import {
    Stack,
    TextField,
    Button,
    Typography,
    Link,
    Radio,
    RadioGroup,
    FormControlLabel,
    FormLabel,
    FormControl,
} from "@mui/material";

import "./register.css";

import Alert from "@mui/material/Alert";

const USER_REGEX = /^[A-z][A-z0-9-_]{3,23}$/;
const PWD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%]).{8,24}$/;
const REGISTER_URL = "/register";

const Register = () => {
    const userRef = useRef();
    const errRef = useRef();

    const [user, setUser] = useState("");
    const [validName, setValidName] = useState(false);
    const [userFocus, setUserFocus] = useState(false);

    const [pwd, setPwd] = useState("");
    const [validPwd, setValidPwd] = useState(false);
    const [pwdFocus, setPwdFocus] = useState(false);

    const [matchPwd, setMatchPwd] = useState("");
    const [validMatch, setValidMatch] = useState(false);
    const [matchFocus, setMatchFocus] = useState(false);

    const [errMsg, setErrMsg] = useState("");
    const [success, setSuccess] = useState(false);

    // type
    const [role, setRole] = useState("volunteer");

    const handleChange = (event) => {
        setRole(event.target.value);
    };

    useEffect(() => {
        userRef.current.focus();
    }, []);

    useEffect(() => {
        setValidName(USER_REGEX.test(user));
    }, [user]);

    useEffect(() => {
        setValidPwd(PWD_REGEX.test(pwd));
        setValidMatch(pwd === matchPwd);
    }, [pwd, matchPwd]);

    useEffect(() => {
        setErrMsg("");
    }, [user, pwd, matchPwd]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        // if button enabled with JS hack
        const v1 = USER_REGEX.test(user);
        const v2 = PWD_REGEX.test(pwd);
        if (!v1 || !v2) {
            setErrMsg("Invalid Entry");
            return;
        }
        try {
            const response = await axios.post(
                REGISTER_URL,
                JSON.stringify({ user, pwd, role }),
                {
                    headers: { "Content-Type": "application/json" },
                    withCredentials: true,
                }
            );
            console.log(response?.data);
            console.log(response?.accessToken);
            console.log(JSON.stringify(response));
            setSuccess(true);
            //clear state and controlled inputs
            //need value attrib on inputs for this
            setUser("");
            setPwd("");
            setMatchPwd("");
        } catch (err) {
            if (!err?.response) {
                setErrMsg("No Server Response");
            } else if (err.response?.status === 409) {
                setErrMsg("Username Taken");
            } else {
                setErrMsg("Registration Failed");
            }
            errRef.current.focus();
        }
    };

    return (
        <>
            {success ? (
                <Stack spacing={3}>
                    <Typography variant="h3" sx={{ px: 0, mb: 5 }}>
                        Success!
                    </Typography>
                    <Link
                        component={NavLink}
                        to="/login"
                        variant="subtitle2"
                        underline="hover"
                    >
                        Sign In
                    </Link>
                </Stack>
            ) : (
                <>
                    <Typography variant="h5" sx={{ px: 5, mb: 0 }}>
                        Your first step towards volunteering for a better future
                    </Typography>
                    <Stack spacing={3}>
                        <Alert
                            severity="error"
                            aria-live="assertive"
                            ref={errRef}
                            className={errMsg ? "errmsg" : "offscreen"}
                        >
                            {errMsg}
                        </Alert>
                        <TextField
                            name="username"
                            label="Username"
                            type="text"
                            id="username"
                            inputRef={userRef}
                            autoComplete="off"
                            onChange={(e) => setUser(e.target.value)}
                            value={user}
                            required
                            aria-invalid={validName ? "false" : "true"}
                            aria-describedby="uidnote"
                            onFocus={() => setUserFocus(true)}
                            onBlur={() => setUserFocus(false)}
                            color={validName ? "success" : "warning"}
                        ></TextField>
                        <p
                            id="uidnote"
                            className={
                                userFocus && user && !validName
                                    ? "instructions"
                                    : "offscreen"
                            }
                        >
                            <FontAwesomeIcon icon={faInfoCircle} color="pink" />
                            4 to 24 characters.
                            <br />
                            Must begin with a letter.
                            <br />
                            Letters, numbers, underscores, hyphens allowed.
                        </p>
                        <TextField
                            name="password"
                            label="Password"
                            type="password"
                            id="password"
                            onChange={(e) => setPwd(e.target.value)}
                            value={pwd}
                            required
                            aria-invalid={validPwd ? "false" : "true"}
                            aria-describedby="pwdnote"
                            onFocus={() => setPwdFocus(true)}
                            onBlur={() => setPwdFocus(false)}
                            color={validPwd ? "success" : "warning"}
                        ></TextField>
                        <p
                            id="pwdnote"
                            className={
                                pwdFocus && !validPwd
                                    ? "instructions"
                                    : "offscreen"
                            }
                        >
                            <FontAwesomeIcon icon={faInfoCircle} color="pink" />
                            8 to 24 characters.
                            <br />
                            Must include uppercase and lowercase letters, a
                            number and a special character.
                            <br />
                            Allowed special characters:{" "}
                            <span aria-label="exclamation mark">!</span>{" "}
                            <span aria-label="at symbol">@</span>{" "}
                            <span aria-label="hashtag">#</span>{" "}
                            <span aria-label="dollar sign">$</span>{" "}
                            <span aria-label="percent">%</span>
                        </p>
                        <TextField
                            name="reenter password"
                            label="Re-enter Password"
                            type="password"
                            id="confirm_pwd"
                            onChange={(e) => setMatchPwd(e.target.value)}
                            value={matchPwd}
                            required
                            aria-invalid={validMatch ? "false" : "true"}
                            aria-describedby="confirmnote"
                            onFocus={() => setMatchFocus(true)}
                            onBlur={() => setMatchFocus(false)}
                            color={validMatch ? "success" : "warning"}
                        ></TextField>
                        <p
                            id="confirmnote"
                            className={
                                matchFocus && !validMatch
                                    ? "instructions"
                                    : "offscreen"
                            }
                        >
                            <FontAwesomeIcon icon={faInfoCircle} color="pink" />
                            Must match the first password input field.
                        </p>
                        <FormControl>
                            <FormLabel id="type-row-radio-buttons-group-label">
                                Type
                            </FormLabel>
                            <RadioGroup
                                row
                                aria-labelledby="type-row-radio-buttons-group-label"
                                name="row-radio-buttons-group"
                                value={role}
                                onChange={handleChange}
                            >
                                <FormControlLabel
                                    value="volunteer"
                                    control={<Radio />}
                                    label="Volunteer"
                                />
                                <FormControlLabel
                                    value="admin"
                                    control={<Radio />}
                                    label="Admin"
                                />
                            </RadioGroup>
                        </FormControl>

                        <Button
                            fullWidth
                            size="large"
                            type="submit"
                            variant="contained"
                            disabled={
                                !validName ||
                                !validPwd ||
                                !validMatch ||
                                (role !== "volunteer" && role !== "admin")
                                    ? true
                                    : false
                            }
                            onClick={handleSubmit}
                        >
                            Sign Up
                        </Button>
                        <p>
                            Already registered?
                            <br />
                            <Link
                                component={NavLink}
                                to="/login"
                                variant="subtitle2"
                                underline="hover"
                            >
                                Sign In
                            </Link>
                        </p>
                    </Stack>
                </>
            )}
        </>
    );
};

export default Register;
